var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPatientWarn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49.045,
    height: 39.236,
    viewBox: "0 0 49.045 39.236",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "exclamation-solid",
    d: "M24.7,23.485a4.349,4.349,0,1,1-4.349-4.349A4.354,4.354,0,0,1,24.7,23.485ZM16.5,1.37l.739,14.787a1.3,1.3,0,0,0,1.3,1.24h3.606a1.3,1.3,0,0,0,1.3-1.24L24.195,1.37A1.3,1.3,0,0,0,22.892,0H17.806A1.3,1.3,0,0,0,16.5,1.37Z",
    transform: "translate(18.331)",
    fill: "#008c98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "user-times-solid",
    d: "M17.166,19.618A9.809,9.809,0,1,0,7.357,9.809,9.808,9.808,0,0,0,17.166,19.618Zm6.866,2.452h-1.28a13.34,13.34,0,0,1-11.173,0H10.3A10.3,10.3,0,0,0,0,32.369v3.188a3.679,3.679,0,0,0,3.678,3.678H30.653a3.679,3.679,0,0,0,3.678-3.678V32.369A10.3,10.3,0,0,0,24.032,22.07Z",
    fill: "#008c98"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPatientWarn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/patient-warn.edea805a.svg";
export { ForwardRef as ReactComponent };